import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import LinkedInHeader from './LinkedInHeader';
import MobileBottomNav from './MobileBottomNav';

function MainLayout({ user, userProfile, createdJds }) {
  const [showBusinessMenu, setShowBusinessMenu] = useState(false);
  const [showMeMenu, setShowMeMenu] = useState(false);
  const [showFloatingButton, setShowFloatingButton] = useState(true);

  useEffect(() => {
    const isHidden = sessionStorage.getItem('hideFloatingTwin') === 'true';
    if (isHidden) {
      setShowFloatingButton(false);
    }
  }, []);

  const toggleFloatingButton = (show) => {
    setShowFloatingButton(show);
    if (show) {
      sessionStorage.removeItem('hideFloatingTwin');
    } else {
      sessionStorage.setItem('hideFloatingTwin', 'true');
    }
  };

  const isMobileMenuOpen = showBusinessMenu || showMeMenu;

  return (
    <div className="main-layout">
      <LinkedInHeader userProfile={userProfile} />
      <MobileBottomNav 
        userProfile={userProfile} 
        showBusinessMenu={showBusinessMenu}
        setShowBusinessMenu={setShowBusinessMenu}
        showMeMenu={showMeMenu}
        setShowMeMenu={setShowMeMenu}
        showFloatingButton={showFloatingButton}
        setShowFloatingButton={toggleFloatingButton}
      />
      <main className="main-content">
        <Outlet context={{ userProfile, createdJds, isMobileMenuOpen, showFloatingButton, setShowFloatingButton: toggleFloatingButton }} />
      </main>
    </div>
  );
}

export default MainLayout;
